import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Link} from "../../link/link";
import {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {EntityLogo} from "../../logos/entity-logo";
import classNames from "classnames";
import styles from "./list.module.scss";

export class ListItemProps extends BaseProps {
  onChange: Function;
  item: EntityViewModel;
  style: Object;
  disableLink: Boolean = false;
  routeProps: Object;
  className: String;
}

export const ListEntityItem = (props: ListItemProps) => {
  const onClick = () => {
    if (props.onChange) {
      return props.onChange(props.item);
    }

    return true;
  };

  const linkProps = {
    routeProps: props.routeProps,
    enabled: !props.disableLink,
    model: props.item.linkModel,
    className: classNames(styles.item_container, props.className),
    onClick,
  }

  const logoProps = {
    className: classNames(styles.item_logo),
    entity: props.item,
    width: 20,
    height: 20,
  }

  return (
    <Link {...linkProps}>
      <EntityLogo {...logoProps}/>
      <div>{props.item.name}</div>
    </Link>
  )
};
